import React from "react";
import { CustomDrawerProps } from "../../external/ensolvers-core-frontend-mui/components/Main/AppContainer";

export const ShellDrawer: React.FC<CustomDrawerProps> = () => null;
